import React, { useState } from "react";

// IMPORTANT: Add your story images here - rename files to use hyphens
// import storyImg1 from "../../images/stories/story-1.jpg";
// import storyImg2 from "../../images/stories/story-2.jpg";
// import storyImg3 from "../../images/stories/story-3.jpg";

const Stories = () => {
  const [activeStory, setActiveStory] = useState(0);

  const stories = [
    {
      id: 1,
      name: "Fatima Ahmadi",
      age: 14,
      role: "Student at Sedaqat Educational Center",
      quote: "Before this school, I had never held a book in my hands. Now I dream of becoming a doctor to help my community.",
      story: "Fatima joined the Sedaqat Educational Center two years ago when it first opened in her neighborhood. Coming from a family where education for girls was not prioritized, her journey has been transformative. She now excels in English and Mathematics, inspiring her younger sisters to follow her path.",
      location: "Dasht-e-Barchi, Kabul",
      program: "Sedaqat Educational Center",
      // image: storyImg1, // Uncomment when you have images
      icon: "📖"
    },
    {
      id: 2,
      name: "Mariam Nazari",
      age: 32,
      role: "Graduate of Women's Sewing Program",
      quote: "The sewing program didn't just teach me a skill—it gave me independence and hope for my family's future.",
      story: "Mariam is a mother of four who completed the OHA Women's Sewing Program. After her husband lost his job, she became the primary earner for her family. Today, she runs a small tailoring business from home and has even hired two other program graduates.",
      location: "Khwaja Bughra, Kabul",
      program: "One Hour for Afghanistan",
      // image: storyImg2,
      icon: "🧵"
    },
    {
      id: 3,
      name: "Ahmad Rahimi",
      age: 11,
      role: "Indoor Soccer Team Member",
      quote: "Soccer taught me that when we work together as a team, we can achieve anything.",
      story: "Ahmad discovered his passion for soccer through the Indoor Soccer Team program. Beyond athletics, the program helped him develop discipline and teamwork skills. His grades improved significantly, and he now mentors younger players on the team.",
      location: "Kabul",
      program: "Indoor Soccer Team",
      // image: storyImg3,
      icon: "⚽"
    },
    {
      id: 4,
      name: "Zahra Karimi",
      age: 16,
      role: "Student at Action Not Word Course",
      quote: "Learning English opened a window to a whole new world. Now I can help translate for doctors visiting our community.",
      story: "Zahra has been attending the Action Not Word Educational Course for three years. Her dedication to learning English has made her an invaluable community resource. She volunteers as a translator at local health clinics and dreams of studying international relations.",
      location: "Qasaba, Kabul",
      program: "Action Not Word Educational Course",
      icon: "🌍"
    }
  ];

  const handlePrevStory = () => {
    setActiveStory((prev) => (prev === 0 ? stories.length - 1 : prev - 1));
  };

  const handleNextStory = () => {
    setActiveStory((prev) => (prev === stories.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="stories-section" data-aos="fade-up">
      <h2 data-aos="fade-down" data-aos-delay="100">
        Stories of Impact
      </h2>
      <p className="stories-subtitle" data-aos="fade-up" data-aos-delay="200">
        Real lives transformed through the power of education
      </p>

      {/* Featured Story */}
      <div className="featured-story" data-aos="zoom-in" data-aos-delay="300">
        <div className="story-icon-large" role="img" aria-label={stories[activeStory].program}>
          {stories[activeStory].icon}
        </div>
        
        <div className="story-quote-container">
          <span className="quote-mark">"</span>
          <blockquote className="story-quote">
            {stories[activeStory].quote}
          </blockquote>
          <span className="quote-mark closing">"</span>
        </div>

        <div className="story-details">
          <h3 className="story-name">{stories[activeStory].name}</h3>
          <p className="story-role">{stories[activeStory].role}</p>
          <p className="story-age">Age {stories[activeStory].age} • {stories[activeStory].location}</p>
        </div>

        <div className="story-content">
          <p>{stories[activeStory].story}</p>
        </div>

        <div className="story-program-tag">
          {stories[activeStory].program}
        </div>

        {/* Navigation */}
        <div className="story-navigation">
          <button 
            className="story-nav-btn prev" 
            onClick={handlePrevStory}
            aria-label="Previous story"
          >
            ←
          </button>
          <div className="story-dots">
            {stories.map((_, index) => (
              <button
                key={index}
                className={`story-dot ${index === activeStory ? 'active' : ''}`}
                onClick={() => setActiveStory(index)}
                aria-label={`Go to story ${index + 1}`}
              />
            ))}
          </div>
          <button 
            className="story-nav-btn next" 
            onClick={handleNextStory}
            aria-label="Next story"
          >
            →
          </button>
        </div>
      </div>

      {/* Story Cards Preview */}
      <div className="stories-grid">
        {stories.map((story, index) => (
          <div 
            key={story.id}
            className={`story-card ${index === activeStory ? 'active' : ''}`}
            onClick={() => setActiveStory(index)}
            data-aos="fade-up"
            data-aos-delay={400 + (index * 100)}
          >
            <div className="story-card-icon" role="img" aria-label={story.program}>
              {story.icon}
            </div>
            <h4>{story.name}</h4>
            <p className="story-card-role">{story.role}</p>
            <p className="story-card-preview">"{story.quote.substring(0, 60)}..."</p>
          </div>
        ))}
      </div>

      {/* Call to Action */}
      <div className="stories-cta" data-aos="fade-up" data-aos-delay="600">
        <p>Every donation creates another story of hope</p>
      </div>
    </div>
  );
};

export default Stories;